import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router/index.js'
import {
  getRoles, setMenu, getMenu
} from "@/utils"
import { ROLE_IDS, isTakeoutRole as checkTakeoutRole } from '@/constants/roles'
import { permissionMap } from './permissionMap'
import { userPermissionGetlist, getUserShoplist, userMenuGetList, permissionGetlist, permissionGetChildren, } from "@/api/basicConfiguration";

Vue.use(Vuex)

// 递归处理权限树，构建权限映射表
function processItem(item, prefix, map) {
  const fullName = prefix ? `${prefix}-${item.name}` : item.name;
  if (item.id) {
    map[fullName] = item.id;
  }
  if (item.sub_list && item.sub_list.length > 0) {
    item.sub_list.forEach(child => {
      processItem(child, fullName, map);
    });
  }
}

// 从用户权限数据构建权限映射表（扁平结构）
// 根据接口返回的数据格式：{ id, permission_id, shop_id, name }
function buildPermissionMapFromUserData(permissions) {
  const map = {};
  if (Array.isArray(permissions)) {
    permissions.forEach(item => {
      if (item.name && item.permission_id) {
        // 使用 name 作为 key，permission_id 作为 value
        map[item.name] = item.permission_id;
      }
    });
  }
  return map;
}

export default new Vuex.Store({
  state: {
    //tags数组
    tags: [],

    //tagsview标签显示隐藏
    isCollapse: false,

    // 登录后取来的用户信息
    user: {
      // 登录得来
      userId: 0,
      userName: '',
      compId: 0,
      compName: '',
      compShortName: '',  // 公司简称，放 LOGO 下面
      shopId: 0,
      roleId: 0,           // 用户角色ID
      roleName: '',        // 用户角色名
      // 后台权限表得来
      permissionIds: [],   // 用户权限功能点
      permissionShopMap: [], // 用户权限点可操作店面
      // 后台用户门店表得来
      userShops: [],
      // 用户允许出现的一级、二级菜单
      userMenuList: [],
    },
    permissionMap: permissionMap, // 权限-功能点中文描述 对照表（初始为静态配置，后续会被动态数据覆盖）

    // 用户在其他页面操作时，选定的用户
    pickupUser: {
      userId: 0,
      userName: '',
    }
  },
  mutations: {
    // 更新用户信息
    setUserInfo(state, userInfo) {
      state.user.userId = userInfo.user_id
      state.user.userName = userInfo.name
      state.user.compId = userInfo.comp_id
      state.user.compName = userInfo.comp_name
      state.user.compShortName = userInfo.comp_short_name
      state.user.roleId = userInfo.role_id
      state.user.roleName = userInfo.role_name
      state.user.shopId = userInfo.shop_id
      state.user.comp_level = userInfo.comp_level
      state.user.part_id = userInfo.part_id
    },
    // 更新用户权限
    setUserPermissions(state, permissions) {
      // 用户的权限功能点
      state.user.permissionIds = permissions.map(item => item.permission_id)

      // 用户的权限功能点对应的店面
      // 将结果改成 map，key 为 permission_id, value 为 shopId 的list
      let permissionsMap = new Map();
      permissions.forEach(item => {
        // 如果 Map 中已有该 permission_id，就将 shop_id 添加到它的数组中
        if (permissionsMap.has(item.permission_id)) {
          let shops = permissionsMap.get(item.permission_id);
          shops.push(item.shop_id);
          permissionsMap.set(item.permission_id, shops);
        } else {
          // 如果没有，就创建一个新的数组，只包含当前的 shop_id
          permissionsMap.set(item.permission_id, [item.shop_id]);
        }
      });
      state.user.permissionShopMap = permissionsMap

      // 【动态权限】从用户权限数据构建权限映射表
      const dynamicMap = buildPermissionMapFromUserData(permissions);
      if (Object.keys(dynamicMap).length > 0) {
        // 合并静态和动态权限映射表，动态的优先级更高
        state.permissionMap = { ...state.permissionMap, ...dynamicMap };
        console.log('✅ 动态权限映射表已更新，共', Object.keys(dynamicMap).length, '个权限点');
      }
    },
    // 更新用户-门店权限
    setUserShopPermissions(state, permissions) {
      // state.permissions = permissions
    },
    // 更新用户-门店信息
    setUserShop(state, shops) {
      state.user.userShops = shops
    },
    // 更新用户-菜单
    setUserMenu(state, MenuList) {
      state.user.userMenuList = MenuList
    },
    setPickupUser(state, userInfo) {
      //
    },
    setPermissionMap(state, map) {
      state.permissionMap = map;
    },
    pushtags(state, val) {
      //如果等于-1说明tabs不存在那么插入，否则什么都不做
      //findindex找角标，循环判断一下，如果等于那么就代表有相同的，就不必添加，如果找不到那就是-1.就添加
      let result = state.tags.findIndex(item => item.name === val.name)
      result === -1 ? state.tags.push(val) : ''
    },
    //关闭标签
    closeTab(state, val) {
      //同上，找角标，然后用角标的位置对应删除一位。splice：这是数组的删除方法
      let result = state.tags.findIndex(item => item.name === val.name)
      state.tags.splice(result, 1)
    },
    //关闭所有tagsview标签
    cleartagsview(state, val) {
      //清空数组
      state.tags = []
      //跳转到首页,val接受传过来的当前路由
      if (val !== "/index") {
        router.push({ path: "/index" })
      }
    },
    cleartagsviews(state, val) {
      //清空数组
      state.tags = []
    },
    //改变tagsview显示隐藏
    changeisshow(state) {
      state.isCollapse = !state.isCollapse
    },
    updateMenuItems(state) {
      // state.menuItems.forEach(item => {
      // item.hidden = item.meta && item.meta.hidden;
      //  });
    },
  },
  actions: {
    // 登录或恢复后，获得的当前用户
    fetchUserInfo({ commit }, userInfo) {
      commit('setUserInfo', userInfo); // 提交 mutation 更新角色
    },
    // 用户在其他页面或模块选取的用户
    fetchPickupUserInfo({ commit }, userInfo) {
      commit('setPickupUser', userInfo); // 提交 mutation 更新角色
    },
    // 首次登录或刷页面后，重新获取后台数据
    // 1、获取用户权限表
    // 2、获取用户所属店面
    // 3、获取基础数据：区域信息
    fetchBackendData({ commit }) {
      Promise.all([
        userPermissionGetlist({ comp_id: this.state.user.compId, user_id: this.state.user.userId }),
        getUserShoplist({ comp_id: this.state.user.compId, user_id: this.state.user.userId }),
        userMenuGetList({ comp_id: this.state.user.compId, user_id: this.state.user.userId }),
      ])
        .then((res) => {
          // 设置用户权限（会自动构建动态权限映射表）
          commit('setUserPermissions', res[0].data)
          commit('setUserShop', res[1].data)
          commit('setUserMenu', res[2].data)

          // 用户菜单，再放一份到 cookie
          setMenu(JSON.stringify(res[2].data))
        })
        .catch((error) => {
          console.error('获取后台数据失败:', error);
        });
    },
    // 刷页面后，恢复 Vuex 数据
    restoreUserData({ commit }) {
      const tokenObj = getRoles() ? JSON.parse(getRoles()) : {}
      const menuObj = getMenu() ? JSON.parse(getMenu()) : ""
      commit('setUserInfo', tokenObj)
      commit('setUserMenu', menuObj)

      // 重拉后台基础数据,包括用户权限数据
      this.dispatch('fetchBackendData')
    },
  },
  getters: {
    // 获取用户角色
    userRole: (state) => state.user.roleId,
    userInfo: (state) => state.user,
    userMenu: (state) => state.user.userMenuList,
    hasPermission: (state) => (description) => {

      // 高级别角色，不受权限表控制
      let roleId = state.user.roleId
      if (roleId == 1 || roleId == 2 || roleId == 3 || roleId == 9) {
        return true
      }
      const featureId = state.permissionMap[description]
      return state.user.permissionIds.includes(featureId) || false
    },
    getPermissionId: (state) => (description) => {
      return state.permissionMap[description];
    },
    isTakeoutRole: (state) => checkTakeoutRole({
      roleId: state.user.roleId,
      roleName: state.user.roleName
    }),
    takeoutRoleId: () => ROLE_IDS.TAKEOUT_UNIT,
  },
  modules: {
  },
})



// WEBPACK FOOTER //
// ./src/store/index.js